<template>
  <div class="foot">
    <!--기록다운로드-->
    <p v-if="isUsingDownload" class="small-link-light" @click="toggleDownloadModal">
      {{ $t('download_call_history') }}
    </p>
    <!--로그아웃-->
    <div class="info-sconai">
      <p class="small dim">Provided with</p>
      <p class="small dim accent">SconAI</p>
      <a v-if="isUsingLogout" class="link-small link-dim" @click="alertLogout">
        {{ $t('logout') }}
      </a>
    </div>
    <DownloadTableModal v-if="showDownloadModal" :chat-type="chatType" :code="code" @close="toggleDownloadModal" />
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';

import DownloadTableModal from '@/components/domains/chat/script-download/ChatScriptDownloadModal.vue';
import { useNotification } from '@/composables/shared/useNotification';
import { useCallStore } from '@/stores/call';
import { TypeCall } from '@/types/common';

withDefaults(
  defineProps<{
    isUsingDownload?: boolean;
    isUsingLogout?: boolean;
  }>(),
  {
    isUsingDownload: false,
    isUsingLogout: false,
  }
);

const { alertLogout } = useNotification();
const callStore = useCallStore();
const route = useRoute();

const showDownloadModal = ref<boolean>(false);

const chatType = computed<TypeCall>(() => {
  return callStore.qrCodeInfo.callType;
});

const code = computed<string>(() => {
  return route.params.code.toString();
});

const toggleDownloadModal = () => {
  showDownloadModal.value = !showDownloadModal.value;
};
</script>

<style scoped lang="scss">
.foot {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  align-items: center;
}

.info-sconai {
  display: flex;
  gap: 0.25rem;
  text-wrap: nowrap;
}
</style>
